import { Fragment, useContext, useState } from "react";
import CartContext from "../../store/cart-context";

import Modal from "../UI/Modal";
import classes from "./Cart.module.css";
//import { FaCcMastercard, FaCcPaypal, FaCcVisa } from "react-icons/fa";
import CartItem from "./CartItem";
import Checkout from "./Checkout";

// Cart wordt gebruikt in App
const Cart = (props) => {
  const [isCheckout, setIsCheckout] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [didSubmit, setDidSubmit] = useState(false);

  const cartCtx = useContext(CartContext);
  console.log(cartCtx);

  //const totalAmount = `€${cartCtx.totalAmount.toFixed(2)}`;  // toFixed(2) werkt niet bij een string.
  //const totalAmount = `€${cartCtx.totalAmount}`; // Zorgt ervoor dat number een string wordt en dan werkt toFixed(2) niet
  const totalAmount = cartCtx.totalAmount.toFixed(2);  // Bij het tonen van het bedrag het euro teken ervoor zetten.
  const hasItems = cartCtx.items.length > 0;

  const cartItemRemoveHandler = (id) => {
    console.log("Te verwijderen id: " + id);
    cartCtx.removeItem(id);
  };

  const cartItemAddHandler = (item) => {
    console.log("Item" + item);
    cartCtx.addItem({ ...item, aankoophoeveelheid: 1 });
  };

  const orderHandler = () => {
    //console.log("orderHandler");
    setIsCheckout(true);
  };

  // Dummy array
  // bind ensures that the idea of the to be added or removed item is passed here to the handler
  // bind pre-configures a function for future execution

  /*            

*/
  const cartItems = (
    <ul className={classes["cart-items"]}>
      {
        /*[{ id: "c1", name: "Sushi", amount: 2, price: 12.99 }]*/
        cartCtx.items.map((item) => (
          <CartItem
            key={item.id}
            naam={item.naam}
            aankoopprijs={item.aankoopprijs}
            aankoophoeveelheid={item.aankoophoeveelheid}
            onAdd={cartItemAddHandler.bind(null, item)}
            onRemove={cartItemRemoveHandler.bind(null, item.id)}
          />
        ))
      }
    </ul>
  );

  const submitOrderHandler = async (userData) => {
    setIsSubmitting(true);
    console.log("submitOrderHandler : userData");
    console.log(userData);

    const response1 = await fetch(
      "https://www.marchouben.nl/php/personalia-post.php",
      {
        method: "POST",
        body: JSON.stringify(userData),
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    const data1 = await response1.json();
    console.log(data1);
    const idPersonalia = data1.last_insert_id;

    const jsonPost = JSON.stringify({
      items: cartCtx.items,
      totalamount: cartCtx.totalAmount,
      idpersonalia: idPersonalia,
    });

    console.log(jsonPost);

    const response2 = await fetch(
      "https://www.marchouben.nl/php/javascript-post.php",
      {
        method: "POST",
        body: jsonPost,
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    const data2 = await response2.json();
    console.log(data2);

    setIsSubmitting(false);
    setDidSubmit(true);
    cartCtx.clearCart();
  };

  /*
        <div className={classes.actions}>
        <button className={classes["button--alt"]} onClick={props.onClose}>
          Sluiten
        </button>
        {hasItems && (
          <button className={classes.button} onClick={submitOrderHandler}>
            Bestellen <FaCcMastercard /> <FaCcPaypal /> <FaCcVisa />
          </button>
        )}
      </div>
  */

  const modalActions = (
    <div className={classes.actions}>
      <button className={classes["button--alt"]} onClick={props.onClose}>
        Sluiten
      </button>
      {hasItems && (
        <button className={classes.button} onClick={orderHandler}>
          Bestellen
        </button>
      )}
    </div>
  );

  const cartModalContent = (
    <Fragment>
      {cartItems}
      <div className={classes.total}>
        <span>Totaalbedrag</span>
        <span>€{totalAmount}</span>
      </div>
      {isCheckout && (
        <Checkout onConfirm={submitOrderHandler} onCancel={props.onClose} />
      )}
      {!isCheckout && modalActions}
    </Fragment>
  );

  const isSubmittingModalContent = (
    <p>De order gegevens worden opgeslagen...</p>
  );

  const didSubmitModalContent = (
    <Fragment>
      <p>Successfully sent the order!</p>
      <div className={classes.actions}>
        <button className={classes.button} onClick={props.onClose}>
          Sluiten
        </button>
      </div>
    </Fragment>
  );

  return (
    <Modal onClose={props.onClose}>
      {!isSubmitting && !didSubmit && cartModalContent}
      {isSubmitting && isSubmittingModalContent}
      {!isSubmitting && didSubmit && didSubmitModalContent}
      {/*
      {cartItems}
      <div className={classes.total}>
        <span>Total Amount</span>
        <span>{totalAmount}</span>
      </div>
      {isCheckout && <Checkout onCancel={props.onClose} />}
      {!isCheckout && modalActions}
      
      <div className={classes.actions}>
        <button className={classes["button--alt"]} onClick={props.onClose}>
          Close
        </button>
        {hasItems && <button className={classes.button}>Order</button>}
      </div>
      */}
    </Modal>
  );
};

export default Cart;
